// Polyfill para garantir compatibilidade do Axios
import "./polyfills";
// Patch do Ant Design v5 para compatibilidade com React 19 (silencia warning e
// corrige uso de APIs legadas como o efeito de "wave" dos botões)
import "@ant-design/v5-patch-for-react-19";
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
// import AppTeste from "./AppTeste";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
// Importa e aplica os fixes globais no início da aplicação
import "./utils/globalFixes";
// Importa o inicializador do sistema de diagnóstico de performance
import { initPerformanceMonitoring } from './performance-monitoring-initializer';
// Importa o Error Boundary para Firebase
import FirebaseErrorBoundary from './components/ErrorBoundary/FirebaseErrorBoundary';

// Ativa monitoramento de performance em ambiente de desenvolvimento
initPerformanceMonitoring();

// ✅ REACT 19: Usar createRoot() API em vez de ReactDOM.render()
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <FirebaseErrorBoundary>
      <App />
      {/* <AppTeste /> */}
    </FirebaseErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
